module.exports = __webpack_public_path__ + "img/ctcOnly-logo-2-10-2020.c5b67094.png";